import React from 'react';
import { Box, Users, Monitor } from 'lucide-react'; // Example icons

const AvexaSection = () => {
  return (
    <div className="w-full">
      {/* 3rd Section: Main Header */}
      <div className="flex flex-col text-center md:pb-5 md:px-6">
        <h2
          className="font-normal mb-6"
          style={{
            color: "#1E2A5A", // Dark navy from image
            fontSize: "clamp(1.8rem, 2.5vw, 2.6rem)",
          }}
        >
          What is Avexa OneCare?
        </h2>

        <div className="max-w-4xl text-center mx-auto">
          <p
            className="leading-relaxed opacity-80"
            style={{ color: "#1E2A5A" }}
          >
            Avexa OneCare is a unified intelligent platform that orchestrates
            the entire healthcare ecosystem—connecting patients, providers,
            data, workflows, and decisions into one seamless system.
          </p>
        </div>
      </div>

      {/* 4th Section: The Intelligence Layer (Light Blue Bar) */}
      <div className="flex flex-col text-center py-8 bg-[#F9FAFF] border-y border-slate-50">
        <p className="text-[#5569A0] font-normal">
          It is not another application.
        </p>
        <p className="text-[#5569A0] font-normal">
          It is the intelligence layer that powers all applications.
        </p>
      </div>

      {/* 5th Section: Feature Cards */}
      <div className="max-w-6xl mx-auto py-16 px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          
          {/* Card 1 */}
          <div className="relative flex flex-col items-center p-8 bg-[#F9FAFF] rounded-xl group hover:shadow-md transition-shadow">
            <div className="absolute -top-4 bg-white p-2 rounded-lg shadow-sm border border-orange-100">
              <Box className="w-6 h-6 text-orange-500" />
            </div>
            <p className="mt-4 text-[#5569A0] font-normal  text-center">
              Modular & scalable architecture
            </p>
          </div>

          {/* Card 2 */}
          <div className="relative flex flex-col items-center p-8 bg-[#F9FAFF] rounded-xl group hover:shadow-md transition-shadow">
            <div className="absolute -top-4 bg-white p-2 rounded-lg shadow-sm border border-orange-100">
              <Users className="w-6 h-6 text-orange-500" />
            </div>
            <p className="mt-4 text-[#5569A0] font-normal  text-center">
              Unified patient journey
            </p>
          </div>

          {/* Card 3 */}
          <div className="relative flex flex-col items-center p-8 bg-[#F9FAFF] rounded-xl group hover:shadow-md transition-shadow">
            <div className="absolute -top-4 bg-white p-2 rounded-lg shadow-sm border border-orange-100">
              <Monitor className="w-6 h-6 text-orange-500" />
            </div>
            <p className="mt-4 text-[#5569A0] font-normal  text-center">
              Built for modern healthcare systems
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AvexaSection;